<template>
  <div class="newsTabs"
    :class="{'oneTabs': tabsData && tabsData.length===1, 'noMb': isTop}">
    <div class="name"
      v-if="tabsData && tabsData.length===1 && tabsData[0].colValue">{{tabsData[0].colValue}}</div>
    <div class="seeMore"
      @click="seeMore()">更多...</div>
    <el-tabs v-model="activeName"
      @tab-click="handleClick">
      <template v-if="tabsData && tabsData.length===1">
        <el-tab-pane v-for="(item, key) in tabsData[0].children"
          :key="key"
          :name="JSON.stringify(key)"
          :class="{'tPl': isTop}"
          :label="item.colValue">
          <template v-for="(tItem, key) in item.records">
            <div class="firstItem"
              @click="openLink(tItem.id)"
              v-if="isTop && key===0"
              :key="key">
              <h3 :class="{'isHot': tItem.isHot && tItem.isHot!=='0'}">{{tItem.title}}<span>{{ tItem.publishTime?tItem.publishTime:tItem.createTime }}</span></h3>
              <p v-if="tItem.digest && tItem.digest!==-1">{{tItem.digest}}</p>
            </div>
            <div class="item" :class="{'isHot': tItem.isHot && tItem.isHot!=='0'}"
              @click="openLink(tItem.id)"
              v-else
              :key="key">
              <span>
                {{tItem.title}}
              </span>
              <em>{{ tItem.publishTime?tItem.publishTime:tItem.createTime }}</em>
            </div>
          </template>
        </el-tab-pane>
      </template>
      <template v-else>
        <el-tab-pane v-for="(item, key) in tabsData"
          :key="key"
          :name="JSON.stringify(key)"
          :class="{'tPl': isTop}"
          :label="item.colValue">
          <template v-for="(tItem, key) in item.records">
            <div class="firstItem"
              @click="openLink(tItem.id)"
              v-if="isTop && key===0"
              :key="key">
              <h3 :class="{'isHot': tItem.isHot && tItem.isHot!=='0'}">{{tItem.title}}<span>{{ tItem.publishTime?tItem.publishTime:tItem.createTime }}</span></h3>
              <p v-if="tItem.digest && tItem.digest!==-1">{{tItem.digest}}</p>
            </div>
            <div class="item" :class="{'isHot': tItem.isHot && tItem.isHot!=='0'}"
              @click="openLink(tItem.id)"
              v-else
              :key="key">
              <span>
                {{tItem.title}}
              </span>
              <em>{{ tItem.publishTime?tItem.publishTime:tItem.createTime }}</em>
            </div>
          </template>
        </el-tab-pane>
      </template>
    </el-tabs>

  </div>
</template>

<script>
export default {
  name: 'NewsTabs',
  props: {
    tabsData: {
      type: Array,
      required: true
    },
    isTop: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      activeName: '0'
    };
  },
  components: {},
  mounted() {},
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
    openLink(id) {
      let routeData = this.$router.resolve({
        name: 'Detail',
        params: { id: id }
      });
      window.open(routeData.href, '_blank');
    },
    seeMore() {
      /* this.$router.push({
        path: `/list/${this.tabsData[this.activeName].id}`
      }); */
      /* let routeData = this.$router.resolve({
        name: 'List',
        params: { type: this.tabsData[this.activeName].id }
      });
       */
      let routeData = '';
      if (this.tabsData && this.tabsData.length === 1) {
        routeData = this.$router.resolve({
          name: 'List',
          params: { type: this.tabsData[0].id },
          query: {
            sType: this.tabsData[0].children[this.activeName].id
          }
        });
      } else {
        routeData = this.$router.resolve({
          name: 'List',
          params: { type: this.tabsData[this.activeName].id }
        });
      }
      window.open(routeData.href, '_blank');
    }
  }
};
</script>

<style lang="less" scoped>
.newsTabs {
  position: relative;
  padding: 0 12px;
  margin-bottom: 18px;
  min-height: 290px;
  .name {
    position: absolute;
    left: 12px;
    top: 0;
    font-size: 18px;
    color: #000;
    font-weight: 600;
    line-height: 35px;
    width: 98px;
    padding: 0 8px;
    &::after {
      content: '';
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 2px;
      background-color: #013f99;
      z-index: 1;
    }
  }
  &.noMb {
    margin-bottom: 0;
  }
  .seeMore {
    position: absolute;
    right: 18px;
    top: 10px;
    font-size: 14px;
    color: #5e5a5a;
    z-index: 2;
    cursor: pointer;
    &:hover {
      color: #999;
    }
  }
  /deep/.el-tabs {
    .el-tabs__header {
      margin-bottom: 16px;
    }
    .el-tabs__item {
      font-size: 18px;
      color: #000;
      font-weight: 600;
      height: 35px;
      line-height: 35px;
      padding: 0 8px !important;
    }
    .el-tabs__item.is-active {
      color: #000;
    }
    .el-tabs__active-bar {
      height: 4px;
      padding: 0 8px;
      box-sizing: content-box;
      left: -8px;
      background-color: #013f99;
    }
    .el-tabs__nav-wrap::after {
      content: '';
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 2px;
      background-color: #013f99;
      z-index: 1;
    }
    .el-tab-pane {
      padding-right: 10px;
      &.tPl {
        padding-left: 10px;
      }
    }
  }
  &.oneTabs {
    /deep/.el-tabs {
      .el-tabs__header {
        padding-left: 98px;
      }
      .el-tabs__item {
        font-size: 16px;
        color: #000;
        font-weight: normal;
        padding: 5px 8px 0 !important;
        height: 35px;
        line-height: 30px;
        box-sizing: border-box;
      }
    }
  }
  .item {
    position: relative;
    padding-right: 120px;
    line-height: 24px;
    font-size: 14px;
    color: #5e5a5a;
    cursor: pointer;
    &:hover {
      color: #999;
    }
    span {
      display: block;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    em {
      position: absolute;
      top: 0;
      right: 0;
    }
  }
  .firstItem {
    border-bottom: 1px solid #c3c3c3;
    padding-bottom: 10px;
    margin-bottom: 8px;
    cursor: pointer;
    &:hover {
      opacity: 0.9;
    }
    h3 {
      position: relative;
      font-size: 16px;
      color: #013f99;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      padding-right: 120px;
      line-height: 23px;
      margin-bottom: 4px;
      span {
        position: absolute;
        top: 0;
        right: 0;
        font-size: 14px;
        color: #5e5a5a;
      }
    }
    p {
      line-height: 23px;
      font-size: 14px;
      color: #5e5a5a;
      line-height: 23px;
      height: 46px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      padding: 0 10px;
    }
  }
}
</style>

